import { useStateManager } from 'react-select';
import { Modal } from '../../../../common/components/modals';
import { useCoverManagement } from '../../hooks/useCoverManagement';
import { useState } from 'react';

interface Props {
    id?: number;
    status: string;
    isOpenModal: boolean;
    handlerReloading: () => void;
    onClose: () => void;
}

export const CoverManagementModal = ({
    id,
    status,
    isOpenModal,
    onClose,
    handlerReloading,
}: Props) => {
    const {
        approveCover,
        rejectCover,
        errorMessage,
        setErrorMessage,
        isLoadingManagement,
    } = useCoverManagement(handlerReloading);

    const [comments, setComments] = useState('');

    const onSubmit = () => {
        if (status == 'aprobar' && id) {
            approveCover(id, comments, handlerClose);
        } else if (status == 'rechazar' && id) {
            rejectCover(id, comments, handlerClose);
        }
    };

    const handlerClose = () => {
        setComments('');
        setErrorMessage('');
        onClose();
    };

    return (
        <Modal
            isOpen={isOpenModal}
            modalTitle={`Desea ${status} este cubrimiento?`}
            onClose={handlerClose}
            onSubmit={onSubmit}
            widthCustom='600px'
            disableSubmit={isLoadingManagement}
        >
            <div className='p-3'>
                {errorMessage && (
                    <div className='alert alert-danger' role='alert'>
                        {errorMessage.toString()}
                    </div>
                )}
                <div className='form-floating'>
                    <textarea
                        className='form-control'
                        placeholder='¿Quieres añadir algún comentario?'
                        id='floatingTextarea2'
                        style={{ height: '100px' }}
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                    ></textarea>
                    <label htmlFor='floatingTextarea2'>
                        ¿Quieres añadir algún comentario?
                    </label>
                </div>
            </div>
        </Modal>
    );
};
